import { business } from "@/config/business";

/**
 * Membuat URL WhatsApp (wa.me) dengan pesan default terenkode.
 * Semua tombol WhatsApp memakai helper ini agar nomor terpusat.
 */
export function getWhatsAppUrl(customMessage) {
  const message = customMessage || business.whatsappDefaultMessage;
  return `https://wa.me/${business.whatsapp.international}?text=${encodeURIComponent(
    message,
  )}`;
}

export default getWhatsAppUrl;
